import type { Checkbox } from '@sats-group/ui-lib/react/checkbox/checkbox.types';
import type { ChipLink } from '@sats-group/ui-lib/react/chip/chip.types';
import type { Radio } from '@sats-group/ui-lib/react/radio/radio.types';
import type { TextInput } from '@sats-group/ui-lib/react/text-input/text-input.types';
import type { ClubElementForMap } from '~/client/components/club-element-for-map/club-element-for-map.types';
import type { FormDialog } from '~/client/components/form-dialog/form-dialog.types';
import type { Layout } from '~/client/components/layout/layout.types';
import type { Map } from '~/client/components/map/map.types';

export enum FilterType {
  Multi = 'multi',
  Single = 'single',
}

type Filter<T, FilterType> = {
  data: T[];
  dialog: FormDialog;
  type: FilterType;
};

export type ClubsOverviewPage = {
  clubs: ClubElementForMap[];
  description?: string;
  filters: {
    removers: ChipLink[];
    selectors: (
      | Filter<Checkbox, FilterType.Multi>
      | Filter<Radio, FilterType.Single>
    )[];
  };
  layout: Layout;
  map?: {
    hide: string;
    key: string;
    map: Map;
    open: boolean;
    show: string;
  };
  noSearchResults: string;
  openingHoursEndpoint: string;
  search: {
    input: TextInput;
    trigger: string;
  };
  title: string;
};
